import React from 'react';
import { IWidget } from 'common';
import { style } from 'typestyle';
import { WallIcon } from '../../Icons/LayoutIcons/Wall';
import { MosaicIcon } from '../../Icons/LayoutIcons/Mosaic';
import { CarouselIcon } from '../../Icons/LayoutIcons/Carousel';

type Type = IWidget['settings']['type'];

interface Props {
  onChange: (type: Type) => any;
  editedWidget: {
    settings: {
      type: Type;
    };
  };
}

export function LayoutSelector({ editedWidget, ...props }: Props) {
  const { type } = editedWidget.settings;
  
  const onChange = (type: Type) => {
    props.onChange(type);
  };

  return (
    <div className={selectClass}>
      <CarouselIcon onClick={() => onChange('carousel')} selected={type === 'carousel'} />
      <WallIcon onClick={() => onChange('wall')} selected={type === 'wall'} />
      <MosaicIcon onClick={() => onChange('mosaic')} selected={type === 'mosaic'} />
    </div>
  );
}
const selectClass = style({
  $nest: {
    '& > *': {
      margin: '0 5px',
    },
  },
});
